import { Injectable } from '@angular/core';
import { ApiUrlHelper } from '../api-url-helper';
import { HttpClientHelper } from '../http-helper';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Injectable()
export class NewsService {
    constructor(
        private _apiUrlHelper: ApiUrlHelper,
        private _httpClientHelper: HttpClientHelper
    ) { }
    private cachced:Observable<any[]> = null;
    private cachced_guess:Observable<any[]> = null;
    getRecommendedNewsList(isNews = true, clearCache = false) {
        if (clearCache) {
            this.cachced = null;
            this.cachced_guess = null
        }
        const apiURL = this._apiUrlHelper.urlBuilder('recommended-news', {
            size: 16,
            isNews: isNews ? 1 : 0,
        });

        switch(isNews) {
            case true: {
                if(this.cachced == null)
                {
                    this.cachced = this._httpClientHelper
                    .get(apiURL).pipe(shareReplay({
                        bufferSize:1,
                        refCount:true
                      }));
                    
                } 
                return this.cachced;
            }
            case false: {
                if(this.cachced_guess == null)
                {
                    this.cachced_guess = this._httpClientHelper
                    .get(apiURL).pipe(shareReplay({
                        bufferSize:1,
                        refCount:true
                      }));
                    
                } 
                return this.cachced_guess;
            }
        }
    }
    clearCache(){
        this.cachced = null;
        this.cachced_guess = null
    }

    // getRecommendedNewsCategories(): Observable<any[]> {
    //     return of(FakeRecommendedNewsCategories);
    // }

}
